import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Journal } from '../models/journal.model';

@Injectable({
  providedIn: 'root'
})
export class JournalService {

  private apiUrl = 'https://be.festivalsousse.com/api/journal';

  constructor(private http: HttpClient) { }

  getAll(): Observable<Journal[]> {
    return this.http.get<Journal[]>(this.apiUrl);
  }

  // Utilise par les autres composants pour enregistrer une action dans le journal
  ajouter(texte: string): Observable<Journal> {
    return this.http.post<Journal>(this.apiUrl, { texte });
  }

  vider(): Observable<void> {
    return this.http.delete<void>(this.apiUrl);
  }
}
